<h2 mat-dialog-title>{{ 'Kreditor.Footer.CookiePolicy' | translate }}</h2>
<mat-dialog-content class="modal-content" [innerHTML]="'CookiePolicy.Content' | translate">
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button [mat-dialog-close]="true" class="button-red">
    {{ 'Cancel' | translate }}
  </button>
</mat-dialog-actions>